import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { http, track } from "@/advisor/api";

const Ctx = createContext(null);
const KEY = "lm_advisor_state";

export const INITIAL = {
  step: "input",
  businessText: "",
  chipKey: null,
  business: null,
  goals: [],
  tools: [],
  tiktokGames: [],
  recommendations: [],
  selected: [],
  extraRecommended: [],
  dismissed: [],
  lastLead: null,
};

const load = () => {
  try {
    return { ...INITIAL, ...JSON.parse(localStorage.getItem(KEY) || "{}") };
  } catch {
    return INITIAL;
  }
};

export const AdvisorProvider = ({ children }) => {
  const [state, setState] = useState(load);
  const [meta, setMeta] = useState(null);
  const [catalog, setCatalog] = useState([]);
  const [drawer, setDrawer] = useState(false);

  useEffect(() => {
    http.get("/advisor/meta").then((r) => setMeta(r.data));
    http.get("/advisor/solutions").then((r) => setCatalog(r.data));
  }, []);

  useEffect(() => localStorage.setItem(KEY, JSON.stringify(state)), [state]);

  const update = useCallback((patch) => setState((s) => ({ ...s, ...patch })), []);

  const toggleSelect = useCallback((slug) => {
    const selected = state.selected.includes(slug) ? state.selected.filter((x) => x !== slug) : [...state.selected, slug];
    if (selected.length) track("project", { business_type: state.business?.key, slugs: selected });
    setState((s) => ({ ...s, selected }));
  }, [state.selected, state.business]);

  const reset = useCallback(() => setState({ ...INITIAL }), []);

  const bySlug = useMemo(() => {
    const m = {};
    [...catalog, ...state.recommendations].forEach((x) => (m[x.slug] = x));
    return m;
  }, [catalog, state.recommendations]);

  const value = { state, update, toggleSelect, reset, meta, catalog, bySlug, drawer, setDrawer };
  return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
};

export const useAdvisor = () => useContext(Ctx);
